import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    outerGrid: {
      padding: '16px',
      marginTop: '16px',
      marginBottom: '1px',
      borderRadius: '10px ',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      '& .fieldLabel': {
        marginBottom: '8px',
      },
    },
    deficiencyActionGrid: {
      marginBottom: 10,
    },
    requierd: {
      color: '#2AAB3F',
    },
    breakLine: {
      border: '1px solid #FFFFFF0D',
    },
    checkboxLabel: {
      width: '100%',
    },
    actionTypeGrid: {
      display: 'flex',
      marginTop: 10,
      marginBottom: 10,
    },
    firstAutoComplete: {
      marginTop: '0px',
    },
    textFieldHeight: {
      height: '44px',
    },
    textMargin: {
      marginBottom: '35px !important',
    },
    operationalDownTimeGrid: {
      display: 'flex',
      paddingTop: 8,
    },
    trafficSafety: {
      color: 'rgb(116 116 116)',
    },
  }),
);

export default useStyles;
